import { ICreateJourneyDTO, ICreateJourneyPayloadDTO } from '../Interfaces/PersonalData.interface';
import { api } from './api.service';

export const postPersonalData = api.injectEndpoints({
  endpoints: build => ({
    createJourney: build.mutation<any, ICreateJourneyDTO>({
      query: data => ({
        url: `/journey`,
        method: 'POST',
        body: data,
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
    }),

    createJourneyRecurrentUser: build.mutation<any, ICreateJourneyPayloadDTO>({
      query: ({ token, data }) => ({
        url: `/portal/v1/me/journey`,
        method: 'POST',
        body: data,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`
        }
      })
    })
  })
});

export const { useCreateJourneyMutation, useCreateJourneyRecurrentUserMutation } = postPersonalData;
